import baseApi from '@store/api/baseApi';

export const orderDetailsApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		fetchFactoryPO: builder.query({
			query: (id) => `/factory-po/${id}`,
			providesTags: ['FactoryPOInfo']
		}),
		updateFactoryPO: builder.mutation({
			query: ({ id, requestBody }) => ({
				url: `/factory-po/${id}`,
				method: 'PUT',
				body: requestBody
			}),
			invalidatesTags: ['FactoryPOInfo']
		}),
		downloadFactoryPO: builder.query({
			query: (id) => `/factory-po/${id}/download`
		}),
		updateDestinationWiseQty: builder.mutation({
			query: ({ id, requestBody }) => ({
				url: `/factory-po/${id}/destination-wise-quantity`,
				method: 'POST',
				body: requestBody
			}),
			invalidatesTags: ['FactoryPOInfo']
		}),
		getAllProgramTypes: builder.query({
			query: () => `/program-types`
		}),
		createProgramType: builder.mutation({
			query: ({ name }) => ({
				url: `/program-types?name=${encodeURIComponent(name)}`,
				method: 'POST'
			})
		}),
		updateProgramType: builder.mutation({
			query: ({ id, name }) => ({
				url: `/program-types/${id}?name=${encodeURIComponent(name)}`,
				method: 'PUT'
			})
		})
	})
});

export const {
	useLazyFetchFactoryPOQuery,
	useUpdateFactoryPOMutation,
	useLazyDownloadFactoryPOQuery,
	useUpdateDestinationWiseQtyMutation,
	useLazyGetAllProgramTypesQuery,
	useCreateProgramTypeMutation,
	useUpdateProgramTypeMutation
} = orderDetailsApi;
